"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeprecatedEnrichAIReducers = exports.manageProductBeingReclassifiedReducer = exports.pageSizeReducer = exports.manageAggregatedAttributesViewReducer = exports.manageListViewModeReducer = exports.productTreeFiltersReducer = exports.catalogChangesReducer = exports.aggregatedAttributesReducer = exports.projectReducer = exports.catalogReducer = exports.DEFAULT = void 0;
const types_1 = require("../actions/types");
const state_1 = require("../state");
const client_constants_1 = require("../../enrich-ai/client/client.constants");
const models_1 = require("../../enrich-ai/models");
exports.DEFAULT = {
    selectedEntities: {
        selectedCatalog: undefined,
        selectedProject: undefined,
        selectedTreeNodePath: undefined,
        productTree: undefined,
        expandedNodes: undefined,
        selectedAttributeNode: null,
        aggregatedAttributes: {
            excludedItems: [],
            collapseState: models_1.CollapseState.Collapse,
            sort: models_1.SortingItem.SortByTextAsc,
            filter: Object.assign({}, state_1.EMPTY_ENRICH_AI_ATTRIBUTES_FILTER),
        },
    },
    changes: {},
    pageSize: client_constants_1.PAGE_SIZE_DEFAULT,
    isAggregatedAttributeViewHidden: false,
    isListViewMode: false,
    productTreeFilters: {
        showEmptyNodes: false,
        showStrategyChanges: false,
    },
    productBeingReclassified: null,
};
// DEPRECATED catalog reducer
const catalogReducer = (state = undefined, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_SELECTED_CATALOG: {
            return action.payload.selectedCatalog;
        }
        case types_1.ENRICH_AI_SET_CATALOG_TAGS: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        default: {
            return state;
        }
    }
};
exports.catalogReducer = catalogReducer;
// DEPRECATED project reducer
const projectReducer = (state = undefined, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_SELECTED_PROJECT: {
            return action.payload.selectedProject;
        }
        case types_1.ENRICH_AI_SET_PROJECT_TAGS: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        default: {
            return state;
        }
    }
};
exports.projectReducer = projectReducer;
// DEPRECATED selectedTreeNodePath reducer
const enrichAISetSelectedTreeNodePathReducer = (state = undefined, action) => (action.type === types_1.ENRICH_AI_SET_SELECTED_TREE_NODE_PATH
    ? action.payload.selectedTreeNodePath
    : state);
// DEPRECATED selectedTree reducer
const enrichAIProductTreeReducer = (state = undefined, action) => (action.type === types_1.ENRICH_AI_SET_PRODUCT_TREE ? action.payload.productTree : state);
// DEPRECATED expandedNodes reducer
const enrichAIExpandedNodesReducer = (state = undefined, action) => (action.type === types_1.ENRICH_AI_SET_EXPANDED_NODES ? action.payload.expandedNodes : state);
// DEPRECATED selectedAttributeNode reducer
const enrichAISelectedAttributeNodeReducer = (state = undefined, action) => (action.type === types_1.ENRICH_AI_SET_SELECTED_ATTRIBUTE_NODE ? action.payload.selectedAttributeNode : state);
// DEPRECATED aggregatedAttributes reducer
const aggregatedAttributesReducer = (state = exports.DEFAULT.selectedEntities.aggregatedAttributes, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_ATTRIBUTES_EXCLUDED_ITEMS: {
            const { excludedItems } = action.payload;
            return Object.assign(Object.assign({}, state), { excludedItems });
        }
        case types_1.ENRICH_AI_SET_ATTRIBUTES_COLLAPSE_STATE: {
            const { collapseState } = action.payload;
            return Object.assign(Object.assign({}, state), { collapseState });
        }
        case types_1.ENRICH_AI_SET_ATTRIBUTES_SORT: {
            const { sort } = action.payload;
            return Object.assign(Object.assign({}, state), { sort });
        }
        case types_1.ENRICH_AI_SET_ATTRIBUTES_FILTER: {
            const { filter } = action.payload;
            return Object.assign(Object.assign({}, state), { filter });
        }
        case types_1.ENRICH_AI_CLEAR_ATTRIBUTES_FILTER: {
            return Object.assign(Object.assign({}, state), { filter: Object.assign({}, state_1.EMPTY_ENRICH_AI_ATTRIBUTES_FILTER) });
        }
        default: {
            return state;
        }
    }
};
exports.aggregatedAttributesReducer = aggregatedAttributesReducer;
// DEPRECATED combined selectedEntities reducer
/**
 * The `selectedEntitiesReducer` handles several entities together
 * because these entities are tightly coupled in their logic.
 *
 * This coupling makes it difficult to manage these states independently without duplicating
 * logic across reducers or introducing unnecessary complexity in action handling.
 *
 * By combining them in a single reducer:
 * - We ensure the relationship between these entities is managed centrally.
 * - Avoid scattered logic or dependencies between reducers.
 * - Keep other reducers (unrelated to this coupling) modular and unaffected.
 *
 * This is a temporary solution until the logic can be decoupled or restructured to better
 * reflect the state relationships (https://groupby.atlassian.net/browse/EN-3905). In the meantime, the `selectedEntities` keeps
 * this specific logic isolated while other reducers remain independent.
 */
const selectedEntitiesReducer = (state = exports.DEFAULT.selectedEntities, action) => {
    var _a;
    const selectedProject = (0, exports.projectReducer)(state.selectedProject, action);
    const selectedCatalog = (0, exports.catalogReducer)(state.selectedCatalog, action);
    const selectedTreeNodePath = enrichAISetSelectedTreeNodePathReducer(state.selectedTreeNodePath, action);
    const productTree = enrichAIProductTreeReducer(state.productTree, action);
    switch (action.type) {
        case types_1.ENRICH_AI_SET_SELECTED_CATALOG: {
            return Object.assign(Object.assign(Object.assign({}, state), exports.DEFAULT.selectedEntities), { selectedProject,
                selectedCatalog });
        }
        case types_1.ENRICH_AI_SET_SELECTED_PROJECT: {
            if ((selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id) === ((_a = state.selectedProject) === null || _a === void 0 ? void 0 : _a.id)) {
                return Object.assign(Object.assign({}, state), { selectedProject });
            }
            return Object.assign(Object.assign(Object.assign({}, state), exports.DEFAULT.selectedEntities), { selectedProject });
        }
        case types_1.ENRICH_AI_SET_SELECTED_TREE_NODE_PATH: {
            return Object.assign(Object.assign({}, state), { selectedTreeNodePath, selectedAttributeNode: exports.DEFAULT.selectedEntities.selectedAttributeNode });
        }
        case types_1.ENRICH_AI_SET_PRODUCT_TREE: {
            return Object.assign(Object.assign(Object.assign({}, state), { productTree }), ((!productTree.rootNodeId || !(selectedTreeNodePath === null || selectedTreeNodePath === void 0 ? void 0 : selectedTreeNodePath.startsWith(productTree.rootNodeId))) && {
                selectedTreeNodePath: exports.DEFAULT.selectedEntities.selectedTreeNodePath,
            }));
        }
        default: {
            const expandedNodes = enrichAIExpandedNodesReducer(state.expandedNodes, action);
            const selectedAttributeNode = enrichAISelectedAttributeNodeReducer(state.selectedAttributeNode, action);
            const aggregatedAttributes = (0, exports.aggregatedAttributesReducer)(state.aggregatedAttributes, action);
            return Object.assign(Object.assign({}, state), { selectedProject,
                selectedCatalog,
                productTree,
                selectedTreeNodePath,
                expandedNodes,
                selectedAttributeNode,
                aggregatedAttributes });
        }
    }
};
const catalogChangesReducer = (state = exports.DEFAULT.changes, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_ADD_CHANGES:
            return enrichAIAddChangesReducer(state, action.payload);
        case types_1.ENRICH_AI_REMOVE_CHANGES:
            return enrichAIRemoveChangesReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.catalogChangesReducer = catalogChangesReducer;
const enrichAIAddChangesReducer = (state, { catalogId, changes: newChanges }) => {
    var _a;
    const catalogChanges = [...((_a = state === null || state === void 0 ? void 0 : state[catalogId]) !== null && _a !== void 0 ? _a : []), ...newChanges];
    return Object.assign(Object.assign({}, state), { [catalogId]: catalogChanges });
};
const enrichAIRemoveChangesReducer = (state, { catalogId, strategyNodePath }) => {
    var _a;
    if (strategyNodePath) {
        const catalogChanges = (_a = state === null || state === void 0 ? void 0 : state[catalogId]) !== null && _a !== void 0 ? _a : [];
        return Object.assign(Object.assign({}, state), { 
            // clear selected node and all nested changes
            [catalogId]: catalogChanges.filter(({ path }) => !path.startsWith(strategyNodePath)) });
    }
    return Object.assign(Object.assign({}, state), { [catalogId]: undefined });
};
// product tree filters reducer
const productTreeFiltersReducer = (state = exports.DEFAULT.productTreeFilters, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_PRODUCT_TREE_FILTERS:
            return enrichAISetTreeFiltersReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.productTreeFiltersReducer = productTreeFiltersReducer;
const enrichAISetTreeFiltersReducer = (state, { productTreeFilters }) => (Object.assign(Object.assign({}, state), productTreeFilters));
// manage list view mode reducer
const manageListViewModeReducer = (state = exports.DEFAULT.isListViewMode, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_IS_LIST_VIEW_MODE:
            return enrichAISetIsListViewModeReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.manageListViewModeReducer = manageListViewModeReducer;
const enrichAISetIsListViewModeReducer = (_, { isListViewMode }) => isListViewMode;
// manage aggregated attributes view reducer
const manageAggregatedAttributesViewReducer = (state = exports.DEFAULT.isAggregatedAttributeViewHidden, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_IS_AGGREGATED_ATTRIBUTE_VIEW_HIDDEN:
            return enrichAISetIsAggregatedAttributeViewHiddenReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.manageAggregatedAttributesViewReducer = manageAggregatedAttributesViewReducer;
const enrichAISetIsAggregatedAttributeViewHiddenReducer = (_, { isAggregatedAttributeViewHidden }) => isAggregatedAttributeViewHidden;
// page size reducer
const pageSizeReducer = (state = exports.DEFAULT.pageSize, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_PAGE_SIZE:
            return enrichAISetPageSizeReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.pageSizeReducer = pageSizeReducer;
const enrichAISetPageSizeReducer = (_, { pageSize }) => pageSize;
// manage product being reclassified reducer
const manageProductBeingReclassifiedReducer = (state = exports.DEFAULT.productBeingReclassified, action) => {
    switch (action.type) {
        case types_1.ENRICH_AI_SET_PRODUCT_BEING_RECLASSIFIED:
            return enrichAISetProductBeingReclassifiedReducer(state, action.payload);
        default: {
            return state;
        }
    }
};
exports.manageProductBeingReclassifiedReducer = manageProductBeingReclassifiedReducer;
const enrichAISetProductBeingReclassifiedReducer = (_, { productBeingReclassified }) => productBeingReclassified;
const createDeprecatedEnrichAIReducers = () => {
    const reducers = {
        selectedEntities: selectedEntitiesReducer,
        changes: exports.catalogChangesReducer,
        productTreeFilters: exports.productTreeFiltersReducer,
        isListViewMode: exports.manageListViewModeReducer,
        isAggregatedAttributeViewHidden: exports.manageAggregatedAttributesViewReducer,
        pageSize: exports.pageSizeReducer,
        productBeingReclassified: exports.manageProductBeingReclassifiedReducer,
    };
    return reducers;
};
exports.createDeprecatedEnrichAIReducers = createDeprecatedEnrichAIReducers;
